module.exports = __webpack_public_path__ + "img/perso.1470e31f.svg";